import Cookies from 'js-cookie';
import uuid4 from 'uuid4';

import { ConfigPublic } from '@/common/config.public';

const ATHENA_USER_COOKIE_STRING = '_ath_usr';
const YEAR_MILLIS = 365 * 24 * 60 * 60 * 1000;

export const getOrCreateAthenaUserIdCookie = (): string => {
  return getOrCreateAthenaUserIdCookieInternal(true);
};

export const extendAthenaUserIdCookie = (): void => {
  const athenaCookie = getOrCreateAthenaUserIdCookieInternal(false);

  setAthenaCookie(athenaCookie);
};

const cookieExpireDate = () => new Date(Date.now() + YEAR_MILLIS);
const getOrCreateAthenaUserIdCookieInternal = (setToBrowser: boolean): string => {
  let athenaCookie = Cookies.get(ATHENA_USER_COOKIE_STRING);
  if (!athenaCookie) {
    athenaCookie = uuid4();
    if (setToBrowser) {
      setAthenaCookie(athenaCookie);
    }
  }

  return athenaCookie;
};

const setAthenaCookie = (athenaCookie: string) => {
  Cookies.set(ATHENA_USER_COOKIE_STRING, athenaCookie, {
    expires: cookieExpireDate(),
    domain: ConfigPublic.AthenaCookieDomain,
  });
};
